// extracted by mini-css-extract-plugin
export default {"edit":"Edit_edit__ME8xv","loader":"Edit_loader__OC2nI","editor":"Edit_editor__2xmxo"};